import styled from 'styled-components';

const Layout = {
  PageContent: styled.div`
    box-shadow: 0px -6px 10px 0px rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 95%;
    background-color: white;
    border-radius: 60px 60px 0px 0px;
    padding: 35px 30px 0px 30px;
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
  `,
};

export default Layout;
